import { useConfiguration } from '@ocx/data-configuration';
import { ExternalIdentityVerificationProvider } from '@ocx/graphql';

import { IDMEProvider } from './providers';

export const ExternalIdentityVerificationController = () => {
  const {
    config: { externalIdentityVerification },
  } = useConfiguration();

  if (!externalIdentityVerification.enabled) return null;

  if (externalIdentityVerification.provider === ExternalIdentityVerificationProvider.Idme) {
    return <IDMEProvider />;
  }

  // Add more providers here as needed

  return null;
};
